function Footer() {
  return (
    <footer
      className="fixed bottom-0 left-0 w-full z-10
                 bg-transparent backdrop-blur-sm"
    >
      <div className="container mx-auto py-3 flex flex-col items-center justify-center">
        
        {/* Copyright */}
        <p className="text-xs text-center font-semibold text-purple-400">
          © {new Date().getFullYear()} <strong>Shagun Dave</strong>
        </p>

        {/* Bottom disclaimer */}
        <p className="text-center mt-1 text-sm font-medium text-purple-300">
          Copy of the content on this website is strictly prohibited while open
          to use with source citations
        </p>
      </div>
    </footer>
  );
}

export default Footer;
